import { Search } from '../../domain'
import type { Locale } from '../../../../types'
import type {
  GeoCodingRepository,
  GeoCodingSearchType,
} from './interfaces/GeoCodingRepository'

export default class SearchUnknownDestinationUseCase extends Search {
  constructor(private repository: GeoCodingRepository) {
    super()
  }

  async execute(
    query: string,
    language: Locale,
    options: GeoCodingSearchType = {},
  ) {
    // Build options with default value for the usecase
    const searchOptions = {
      autocomplete: true,
      language,
      limit: 4,
      permanent: false,
      proximity: this.centerCoordinates,
      types: ['place', 'country', 'region'] as const,
      ...options,
    }
    // Apply some logic before firing the API
    if (searchOptions.permanent) {
      console.warn(
        "Using the 'permanent' option might increase the cost of the GeoCoding third-party service!",
      )
    }

    try {
      // Launch the API
      const results = await this.repository.forwardSearch(query, searchOptions)
      // Apply some business logic on the API response
      return results
    } catch (err) {
      console.error('SearchUnknownDestinationUseCase', err)
      return []
    }
  }
}
